module.exports = __webpack_public_path__ + "img/arrow-rotate-right.df597434.svg";